import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const PlusIcon = React.memo(function PlusIcon(props: TPlusIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Plus" {...props}>
            <path
                fill="currentColor"
                d="M10.25 15.4C10.25 15.7314 10.5186 16 10.85 16H11.15C11.4814 16 11.75 15.7314 11.75 15.4V11.75H15.4C15.7314 11.75 16 11.4814 16 11.15V10.85C16 10.5186 15.7314 10.25 15.4 10.25H11.75V6.6C11.75 6.26863 11.4814 6 11.15 6H10.85C10.5186 6 10.25 6.26863 10.25 6.6V10.25H6.6C6.26863 10.25 6 10.5186 6 10.85V11.15C6 11.4814 6.26863 11.75 6.6 11.75H10.25V15.4Z"
            />
        </IconBase>
    );
});

export default PlusIcon;

// #region Types

export type TPlusIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <PlusIcon /> : { ...IconBaseExample, render: PlusIcon };

// #endregion
